import { AxiosError } from "axios";
import { useApi } from "../hooks/useApi";
import { ILoginFormData } from "../interfaces/formLoginRegister/dataFormLogin";

const api = useApi();

export async function loginUser(loginFormData: ILoginFormData): Promise<{ role: "TRAVELER" | "RESIDENT", token: string, refreshToken: string, notifNumber: number, pseudo: string, badges: string[], region: string | null }> {
  try {
    const { data } = await api.post("auth/login", loginFormData);
    return data;
  } catch (error) {
    if (error instanceof AxiosError && error.response) {
      throw new Error(error.response.data.message || "Erreur lors de la connexion.");
    }
    throw error;
  }
}

export async function logoutUser() {
  try {

    const response = await api.post("auth/logout");
    return response;
  } catch (error) {
    throw error;
  }
}

export async function askPwdForgot(formData: { email: string }) {
  try {
    const response = await api.post("auth/ask-pwd-forgot", formData);

    return response;
  }
  catch (error) {

    throw error;
  }
}

export async function resetPwd(formData: { token: string, newPassword: string, confirmPassword: string }) {
  try {
    const response = await api.post("auth/submit-reset-password", formData);
    return response;
  }
  catch (error) {
    if (error instanceof AxiosError) {
      throw error.status;
    }
    else throw error;
  }
}